module.exports = __webpack_public_path__ + "img/default-magic-stick.7ec15757.svg";